<template>
  <div class="pr-4 pl-3 py-3 space-y-3 cursor-pointer">
    <div class="search-box">
      <template v-if="!loading">
        <div
          v-if="courses.length"
          class="lessons"
        >
          <div class="lessons-header">
            <span>دروس</span>
          </div>
          <div class="lessons-search-result list">
            <div
              v-for="(course, index) in courses"
              :key="index"
              class="
                flex
                items-center
                text-gray-medium
                hover:text-blue-primary
                transition-colors
              "
              @click="getCourseList(course)"
            >
              <AppIcon
                name="baseline-menu-book"
                size="tiny"
              />
              <span class="text__sub--1 mr-2">
                {{ course.name }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="teachers.length"
          class="teachers"
          :class="{ 'mt-6': courses.length > 0 }"
        >
          <div class="teachers-header">
            <span>اساتید</span>
          </div>
          <div class="teachers-serach-result list">
            <a
              v-for="(teacher, index) in teachers"
              :key="index"
              :href="$routeName.getTutorProfileLink($config, teacher.username)"
              class="
                flex
                items-center
                text-gray-medium
                hover:text-blue-primary
                transition-colors
                teacherListTeacherProfileView
              "
              @click="$emit('closeList')"
            >
              <AppIcon
                name="human-male-board"
                size="tiny"
              />
              <span class="text__sub--1 mr-2">
                {{ teacher.name }}
              </span>
            </a>
          </div>
        </div>
      </template>
      <p
        v-if="!courses.length && !teachers.length && !loading"
        class="text__sub--2 text-gray-medium text-center"
      >
        {{ $t("filter.empty_list") }}
      </p>
      <p
        v-if="loading"
        class="text__sub--2 text-gray-medium text-center"
      >
        {{ $t("filter.searching_mode") }}
      </p>
    </div>
  </div>
</template>

<script>
import AppIcon from '@library/element/icon'
import filter from '@mixins/filter'

export default {
  name: 'SearchBoxList',
  components: { AppIcon },
  mixins: [filter],
  props: {
    query: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    courses: {
      type: Array,
      default: () => []
    },
    teachers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    async getCourseList (item) {
      try {
        this.$emit('closeList')
        const { link_parameters } = await this.$store.dispatch(
          'local/getLinkParameters',
          { course_id: item.id }
        )
        const route = `${this.$routeName.teacher_list_link}/${this.joinParams(link_parameters)}`
        window.location = this.$routeName.getTeacherListLink(this.$config, route)
      } catch (error) {
        this.$logger.captureException({ error })
      }
    }
  }
}
</script>
<style lang="scss">
.search-box {
  .teachers {
    @apply mb-6;
    &-header {
      @apply mb-3 pb-1 border-b border-gray-light border-solid text-blue-primary text__sub--3;
    }
    .list {
      @apply space-y-3;
    }
  }
  .lessons {
    &-header {
      @apply mb-3 pb-1 border-b border-gray-light border-solid text-blue-primary text__sub--3;
    }
    .list {
      @apply space-y-3;
    }
  }
}
</style>
